import { render, staticRenderFns } from "./labelToggle.vue?vue&type=template&id=0fcfd0d6&scoped=true&"
import script from "./labelToggle.vue?vue&type=script&lang=js&"
export * from "./labelToggle.vue?vue&type=script&lang=js&"
import style0 from "./labelToggle.vue?vue&type=style&index=0&id=0fcfd0d6&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fcfd0d6",
  null
  
)

export default component.exports